var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTripReady(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a103e9d8-ae13-4317-8b5c-d52b97b467b4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trip-ready") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2A10,10,0,1,0,22,12,10.00362,10.00362,0,0,0,12,2ZM6.83148,16.5v-9l6,4.5Zm7.88617-1.03473a.09591.09591,0,0,1-.09564.09564h-1.3244a.0959.0959,0,0,1-.09558-.09564V8.53473a.0959.0959,0,0,1,.09558-.09564H14.622a.09591.09591,0,0,1,.09564.09564Zm2.45087,0a.0959.0959,0,0,1-.09558.09564h-1.3244a.09591.09591,0,0,1-.09565-.09564V8.53473a.09591.09591,0,0,1,.09565-.09564h1.3244a.0959.0959,0,0,1,.09558.09564Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripReady);
export default __webpack_public_path__ + "static/media/trip_ready.a461c745.svg";
export { ForwardRef as ReactComponent };